import React, { createContext, useState, useEffect, useContext } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import find from 'lodash.find';

import GetParameter from '../utils/get-param';
import allStatesData from '../utils/state-data';
import slugify from '../utils/slugify';

export const UserDataContext = createContext(null);

// Spanish content isn't supported this season, so language is hardcoded to 'en'
// and the `lang` url param has been removed entirely (it used to let ?lang=es
// resurface old Spanish content).
const selectedLanguage = 'en';

const UserDataProvider = (props) => {
    const [selectedState, setSelectedState] = useState(null);

    const location = useLocation();
    const stateParam = GetParameter('state', location.search);
    const stateRouteMatch = matchPath(location.pathname, {
        path: '/state/:stateSlug',
    });

    useEffect(() => {
        if (stateRouteMatch) {
            const matchedState = find(
                allStatesData,
                (state) =>
                    slugify(state.name) === stateRouteMatch.params.stateSlug,
            );
            setSelectedState(matchedState ? matchedState.name : null);
        } else if (stateParam) {
            setSelectedState(stateParam);
        } else {
            setSelectedState(null);
        }
        // eslint-disable-next-line
    }, [location.pathname, location.search]);

    return (
        <UserDataContext.Provider
            value={{
                selectedLanguage,
                selectedState,
            }}
            {...props}
        />
    );
};

export const useUserDataContext = () => useContext(UserDataContext);

export default UserDataProvider;
